/**
 * Fire-and-forget staff clock activity logging.
 * Never throws to callers — logging must not block attendance punches.
 */
import { addDoc, collection, Timestamp } from '@/services/neonFirestore'
import { db } from '@/firebase/config'
import { applySubCompanyMetadata } from '@/utils/subCompanyScope'

/**
 * @param {object} params
 * @param {object} [params.authStore]
 * @param {'clock-in'|'clock-out'} params.action
 * @param {'attempted'|'success'|'failed'|'cancelled'} params.outcome
 * @param {'modern'|'post-login'|'face'|string} [params.source]
 * @param {string|null} [params.reason]
 * @param {string|null} [params.attendanceId]
 * @param {string|null} [params.branchId]
 */
export async function logStaffActivity({
  authStore,
  action,
  outcome,
  source = 'modern',
  reason = null,
  attendanceId = null,
  branchId = null,
} = {}) {
  try {
    const profile = authStore?.userProfile
    const user = authStore?.user
    if (!user?.uid || !profile?.companyId) return null
    if (action !== 'clock-in' && action !== 'clock-out') return null
    if (!['attempted', 'success', 'failed', 'cancelled'].includes(outcome)) return null

    const payload = applySubCompanyMetadata(
      {
        userId: user.uid,
        companyId: profile.companyId,
        branchId: branchId || profile.branchId || null,
        action,
        outcome,
        source: source || 'modern',
        reason: reason ? String(reason).slice(0, 500) : null,
        attendanceId: attendanceId || null,
        createdAt: Timestamp.fromDate(new Date()),
      },
      profile,
    )

    const ref = await addDoc(collection(db, 'staffActivityLogs'), payload)
    return ref?.id || null
  } catch (error) {
    console.warn('[staffActivityLog] failed to write log:', error?.message || error)
    return null
  }
}
